import React, { useState, useEffect, useRef } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { useTranslation } from "react-i18next";


import jouerFR from "./assets/jouerFR.png";
import reglesFR from "./assets/reglesFR.png";
import paramFR from "./assets/paramFR.png";

import jouerEN from "./assets/jouerEN.png";
import reglesEN from "./assets/reglesEN.png";
import paramEN from "./assets/paramEN.png";

import click from "./assets/sounds/click.mp3";
import { usePreferences } from "./hooks/usePreferences";

import "./Menu.css";


export default function Menu() {
  const navigate = useNavigate();
  const location = useLocation();
  const profile = location.state?.profile || null; // profil sélectionné
  const game = location.state?.game;       // jeu sélectionné
  const token = localStorage.getItem("token") || "";
  const { soundEnabled, timerSoundEnabled } = usePreferences(token);
  const timerAudioRef = useRef(null); // 🔊 ref pour le son tic-tac
  const { t, i18n } = useTranslation();
  
useEffect(() => {
  if (profile?.preferredLanguage) {
    i18n.changeLanguage(profile.preferredLanguage.toLowerCase());
  }
}, [profile, i18n]);

const lang = i18n.language?.split("-")[0] || "en";

    const menuImages = {
      fr: {
        play: jouerFR,
        rules: reglesFR,
        settings: paramFR,
      },
      en: {
        play: jouerEN,
        rules: reglesEN,
        settings: paramEN,
      },
    };

    const images = menuImages[lang] || menuImages.fr;

    const playSound = (sound, isTimer = false) => {
    if ((isTimer && !timerSoundEnabled) || (!isTimer && !soundEnabled)) return;

    if (isTimer) {
      // stoppe un éventuel son déjà lancé
      if (timerAudioRef.current) {
        timerAudioRef.current.pause();
        timerAudioRef.current.currentTime = 0;
      }
      timerAudioRef.current = new Audio(sound);
      timerAudioRef.current.loop = true; // tic-tac en continu
      timerAudioRef.current.play();
    } else {
      const audio = new Audio(sound);
      audio.play();
    }
  };


  return (
    <div className="menu-container">
      <h1>{t("menu.title")}</h1>
      <div className="menu-grid-wrapper">
        <div className="menu-grid">
          <div className="menu-card" onClick={() => { playSound(click); navigate("/game", { state: { profile, game } }); }}>
            <img src={images.play} alt="Play" className="menu-image" />
          </div>

          <div className="menu-card" onClick={() => { playSound(click); navigate("/rules", { state: { profile, game } }); }}>
            <img src={images.rules} alt="Rules" className="menu-image" />
          </div>

          <div className="menu-card" onClick={() => { playSound(click); navigate("/settings", { state: { profile, game } }); }}>
            <img src={images.settings} alt="Settings" className="menu-image" />
          </div>
        </div>
      </div>

      <button className="back-btn" onClick={() => {playSound(click);navigate(-1)}}>
        ←
      </button>
    </div>
  );

}
